/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import useWhiteboardStore from "@/stores/useWhiteboardStore";
import Indicator from "./Indicator";

export default function PlayerIndicator() {
	const userName = useWhiteboardStore((state) => state.userName);
	const penColor = useWhiteboardStore((state) => state.penColor);
	const toolState = useWhiteboardStore((state) => state.toolState);

	return <Indicator id="player-indicator" color={penColor} icon={toolState} name={userName} isPlayer={true} />;
}
